module.exports = __webpack_public_path__ + "../static/img/autobackups_logo.3e428564.png";